type TenantNode = {
  id: string;
  name: string;
  logoId?: string | null;
  colors?: {
    primaryColor?: string | null;
    secondaryColor?: string | null;
    accentColor?: string | null;
  } | null;
  subTenants?: TenantNode[];
};

export const findTenantWithParent = (
  tenants: TenantNode[] | undefined,
  tenantId?: string
): { tenant?: TenantNode; parent?: TenantNode } => {
  if (!tenants?.length || !tenantId) return {};

  for (const tenant of tenants) {
    if (tenant.id === tenantId) {
      return { tenant };
    }

    const subTenant = tenant.subTenants?.find((item) => item.id === tenantId);
    if (subTenant) {
      return { tenant: subTenant, parent: tenant };
    }
  }

  return {};
};

export const findSingleTenant = (tenants: TenantNode[] | undefined): TenantNode | undefined => {
  return tenants?.length === 1 ? tenants[0] : undefined;
};

export const findCurrentTenant = (
  tenants: TenantNode[] | undefined,
  tenantId?: string
): TenantNode | undefined => {
  const tenant = findTenantWithParent(tenants, tenantId).tenant;

  if (tenant || !tenantId) return tenant;

  return findSingleTenant(tenants);
};
